export const getHistoryData = ({schema}) => {
    return schema.schema;
};

export const getCompleteCode = ({schema}) => {
    return schema.code;
};

export const getViews = ({schema}) => {
    return schema;
}

export const getViewInterruptAction = ({schema}) => {
    return schema?.interrupt || false
}